<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesQualityProductionSampleItemResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      edit-disable
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button-group>
                                        <em-button type="fillTemplate"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="填写检验数据"
                                                   :disabled="$_notChecked"
                                                   :busy="loading"
                                                   @click="$refs.inputList.showModal()">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="fillTemplate"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="填写检验数据"
                                                   :busy="loading"
                                                   @click="openInputModal(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>


        <ReBModal ref="inspectInput" header="检验数据填写" @ok="submitInspectData">
            <diverse-input v-for="(item,index) in inputFormConfig" :key="index"
                           :value.sync="item.value"
                           :config="item"></diverse-input>
        </ReBModal>

        <re-b-modal ref="inputList" header="检验数据填写" @ok="submitBatchInspectData">
            <mini-table ref="inputListTable" read-only :fields="fields" :items="checkedRows"></mini-table>
        </re-b-modal>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-10-14 16:35:28

import emCommonListMixin from "@/mixin/em/common/list";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import moment from 'moment'
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "mintalMesQualityProductionSampleItemListView",
    components: {MiniTable, DiverseInput, ReBModal},
    mixins: [emCommonListMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            inputFormConfig: [
                {
                    label: '实测值',
                    name: 'measurement',
                    value: '',
                    type: 'number', require: true
                },
                {
                    label: '检验人',
                    name: 'inspector',
                    value: '',
                    type: 'input'
                },
                {
                    label: '检验时间',
                    name: 'inspectTime',
                    value: moment(new Date()).format(
                        this.$t("em.datetime.format.viewMode")
                    ),
                    type: 'datetime'
                }
            ],
            selectedRow: null,

            fields: [
                {key: 'compoundName', label: '元素名称'},
                {key: 'upperLimit', label: '上限值'},
                {key: 'lowerLimit', label: '下限值'},
                {key: 'compoundUnit', label: '单位'},
                {key: 'measurement', label: '实测值', isInput: true},
            ],
            loading: false
        }
    },
    methods: {
        openInputModal(row) {
            this.selectedRow = row;
            this.$refs.inspectInput.showModal();
        },
        submitInspectData() {
            let data = {};
            data.id = this.selectedRow.id;
            for (let item of this.inputFormConfig) {
                data[item.name] = item.value;
            }
            let tempList = [];
            tempList.push(data);
            this.submitData(tempList);
        },
        submitBatchInspectData() {
            let data = this.$refs.inputListTable.columnEditData();
            this.submitData(data);
        },
        submitData(data) {
            this.loading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_QUALITY_URL + "/mintalMesQualityProductionSampleItem/inputBatch",
                data: data
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.loading = false);
        }
    }
};
</script>
